module.exports = __webpack_public_path__ + "img/alarm1.a18f5df5.png";